import * as React from 'react';
import styled, {css} from 'styled-components'
import {
    ConstColor,
    ConstFontStyle,
    ConstFontWeight,
    ConstMargin
} from "../../../../config/styles_const/styles_const";

interface IProps
    extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLParagraphElement>, HTMLParagraphElement> {
    icon?: string;
    iconPrefix?: "900" | "400" | "300"; // fontawesom solid 900 regular 400 light 300
    bold?: boolean;
}

const MenuParagraphDefault: React.FC<IProps> = (props) => {

    const { icon, bold, iconPrefix, children, ...PProps } = props;

    return<p {...PProps}>{children}</p>;

};

const MenuParagraph = styled(MenuParagraphDefault)`
    color: ${ConstColor.Base};
    font-style: normal;
    font-weight: ${props => props.bold ? ConstFontWeight.BOLD : ConstFontStyle.MenuParagraphDefault.fontWeight};
    font-size: ${ConstFontStyle.MenuParagraphDefault.fontSize};
    line-height: ${ConstFontStyle.MenuParagraphDefault.lineHeight};
    ${props => props.icon && css`
        ::before {
            margin-right: ${ConstMargin.ParagraphIconRight};
            content: ${props.icon};
            font-family: "Font Awesome 5 Free";
            font-weight: ${props.iconPrefix ? props.iconPrefix : "900"};
        }
    `}
`;

export default MenuParagraph;


// WEBPACK FOOTER //
// ./src/presentation/common/atom/text/menu_paragraph.tsx